import { createFileRoute } from '@tanstack/react-router'

import {
  getCurriculumDetailsQueryOptions,
  CurriculumManagementDetailsView
} from '@/modules/curriculumsManagement'

export const Route = createFileRoute('/_auth/curricula/$curriculumId/')({
  component: CurriculumManagementDetailsView,
  loader: async ({ context, params }) =>
    context.queryClient.ensureQueryData(
      getCurriculumDetailsQueryOptions(params.curriculumId)
    )
})
